import React, { Component } from 'react';
import withRouter from "../../Utils/withRouter";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { IsRequired, SubmitButton } from '../../Components/InputElements';
import Select from "react-select";

const indianStates = [
  { value: "AP", label: "Andhra Pradesh",  },
  { value: "AR", label: "Arunachal Pradesh",  },
  { value: "AS", label: "Assam",  },
  { value: "BR", label: "Bihar",  },
  { value: "CG", label: "Chhattisgarh",  },
  { value: "GA", label: "Goa",  },
  { value: "GJ", label: "Gujarat",  },
  { value: "HR", label: "Haryana",  },
  { value: "HP", label: "Himachal Pradesh",  },
  { value: "JH", label: "Jharkhand",  },
  { value: "KA", label: "Karnataka",  },
  { value: "KL", label: "Kerala",  },
  { value: "MP", label: "Madhya Pradesh",  },
  { value: "MH", label: "Maharashtra",  },
  { value: "MN", label: "Manipur",  },
  { value: "ML", label: "Meghalaya",  },
  { value: "MZ", label: "Mizoram",  },
  { value: "NL", label: "Nagaland",  },
  { value: "OD", label: "Odisha",  },
  { value: "PB", label: "Punjab",  },
  { value: "RJ", label: "Rajasthan",  },
  { value: "SK", label: "Sikkim",  },
  { value: "TN", label: "Tamil Nadu",  },
  { value: "TG", label: "Telangana",  },
  { value: "TR", label: "Tripura",  },
  { value: "UP", label: "Uttar Pradesh",  },
  { value: "UK", label: "Uttarakhand",  },
  { value: "WB", label: "West Bengal",  },
  { value: "AN", label: "Andaman and Nicobar Islands",  },
  { value: "CH", label: "Chandigarh",  },
  { value: "DN", label: "Dadra and Nagar Haveli",  },
  { value: "DD", label: "Daman and Diu",  },
  { value: "DL", label: "Delhi",  },
  { value: "JK", label: "Jammu and Kashmir",  },
  { value: "LA", label: "Ladakh",  },
  { value: "LD", label: "Lakshadweep",  },
  { value: "PY", label: "Puducherry",  }
];

class CompanyStatutory extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      postLoading: false,
      responseModal: false,
      company_id: 0,
      Corporate_identification_number: "",
      pan_number: "",
      tan_number: "",
      gstin_number: "",
      pf_number: "",
      establishment_under_pf: "",
      pf_registration_number: "",
      establishment_under_esic: "",
      esic_registration_number: "",
      establishment_under_pt: "",
      pt_registration_number: "",
      establishment_under_lwf: "",
      lwf_registration_number: "",
      errors: {},
      responseList:[]
    };
    this.closeRef = React.createRef();
    this.Corporate_identification_number_ref = React.createRef();
    this.pan_number_ref = React.createRef();
    this.tan_number_ref = React.createRef();
    this.gstin_number_ref = React.createRef();
    this.pf_number_ref = React.createRef();
    this.establishment_under_pf_ref = React.createRef();
    this.pf_registration_number_ref = React.createRef();
    this.establishment_under_esic_ref = React.createRef();
    this.esic_registration_number_ref = React.createRef();
    this.establishment_under_pt_ref = React.createRef();
    this.pt_registration_number_ref = React.createRef();
    this.establishment_under_lwf_ref = React.createRef();
    this.lwf_registration_number_ref = React.createRef();
    
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    console.log("this.props?.company_id",id);
    if (id !== 0 && id) {
      this.setState({ loadingList: true, company_id: id },
        ()=>{ this.GetInfo() }
      );
    } else {
      this.resetForm();
    }
  }


  GetInfo = () => {
    const { apiURL, apiHeaderJson } = this.context;
    const headers = apiHeaderJson;
    axios.get(`${apiURL}Companies/GetCompanyInfo?company_id=${this.state.company_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true && data.length > 0) {
        this.setState(
          {
            Corporate_identification_number: data[0]?.Corporate_identification_number,
            pan_number: data[0]?.pan_number,
            tan_number: data[0]?.tan_number,
            gstin_number: data[0]?.gstin_number,
            pf_number: data[0]?.pf_number,
            establishment_under_pf: data[0]?.establishment_under_pf,
            pf_registration_number: data[0]?.pf_registration_number,
            establishment_under_esic: data[0]?.establishment_under_esic,
            esic_registration_number: data[0]?.esic_registration_number,
            establishment_under_pt: data[0]?.establishment_under_pt,
            pt_registration_number: data[0]?.pt_registration_number,
            establishment_under_lwf: data[0]?.establishment_under_lwf,
            lwf_registration_number: data[0]?.lwf_registration_number,
          }
        )
      }
    });
  }

  handleErrorAutoScroll=()=>{
    if (this.state.errors.Corporate_identification_number && this.Corporate_identification_number_ref.current) {
        this.Corporate_identification_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.Corporate_identification_number_ref.current.focus();
    } 
    if (this.state.errors.pan_number && this.pan_number_ref.current) {
        this.pan_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.pan_number_ref.current.focus();
    } 
    if (this.state.errors.tan_number && this.tan_number_ref.current) {
        this.tan_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.tan_number_ref.current.focus();
    } 
    if (this.state.errors.gstin_number && this.gstin_number_ref.current) {
        this.gstin_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.gstin_number_ref.current.focus();
    } 
    if (this.state.errors.pf_number && this.pf_number_ref.current) {
        this.pf_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.pf_number_ref.current.focus();
    } 
    if (this.state.errors.establishment_under_pf && this.establishment_under_pf_ref.current) {
        this.establishment_under_pf_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.establishment_under_pf_ref.current.focus();
    } 
    if (this.state.errors.pf_registration_number && this.pf_registration_number_ref.current) {
        this.pf_registration_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.pf_registration_number_ref.current.focus();
    } 
    if (this.state.errors.establishment_under_esic && this.establishment_under_esic_ref.current) {
        this.establishment_under_esic_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.establishment_under_esic_ref.current.focus();
    } 
    if (this.state.errors.esic_registration_number && this.esic_registration_number_ref.current) {
        this.esic_registration_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.esic_registration_number_ref.current.focus();
    } 
    if (this.state.errors.establishment_under_pt && this.establishment_under_pt_ref.current) {
        this.establishment_under_pt_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.establishment_under_pt_ref.current.focus();
    } 
    if (this.state.errors.pt_registration_number && this.pt_registration_number_ref.current) {
        this.pt_registration_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.pt_registration_number_ref.current.focus();
    } 
    if (this.state.errors.establishment_under_lwf && this.establishment_under_lwf_ref.current) {
        this.establishment_under_lwf_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.establishment_under_lwf_ref.current.focus();
    } 
    if (this.state.errors.lwf_registration_number && this.lwf_registration_number_ref.current) {
        this.lwf_registration_number_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.lwf_registration_number_ref.current.focus();
    } 
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors,postLoading:false },()=>{ this.handleErrorAutoScroll()});
      this.setState({postLoading:false});
      return;
    }

    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;

    this.setState({ postLoading: true, });
    const formData = {

    }

    if (this.props.params.company_id !== 0) {
      formData.company_id = this.props.params.company_id;
    }
    Swal.fire({
      title: "Are you sure?",
      text: `You want you to create company!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Create!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
      Swal.fire({
        title: 'Please wait...',
        text: 'Processing your request',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        }
      })
      axios.post(`${apiURL}Companies/CreateCompany`, formData, { headers })
      .then((response) => {
        Swal.close()
        const { success,company_setup_results } = response.data;
        if (success === true) {
          this.resetForm();
          setTimeout(() => {
            if (this.props.params.company_id) {
              this.closeRef.current.click();
            }
          }, 1000);
          this.setState({ postLoading: false, });
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
          }).then(() => {
            this.setState({
              responseModal:true,
              responseList:company_setup_results,
              postLoading:false
            });
          });
        } else {
          this.setState({ postLoading: false });
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,  
            allowOutsideClick: false,
          });
        }

      }).catch((error)=>{
        Swal.close();
        Swal.fire({
          title: `<strong>${'Failed'}</strong>`,
          text: `Opps..! Something went wrong.`,
          icon: 'error',
          showConfirmButton: true, 
          allowOutsideClick: false,
        });
      }).finally(()=>{
        Swal.close();
        this.setState({ postLoading: false });
      });
    }});
  };

  resetForm = () => {
    this.setState({
      postLoading: false,
      errors: {}
    });
  };


  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked ? 1 : 0
    });
  };
  handleSelectChange = (name, value) => {
    console.log(value);
    this.setState({
      [name]: value
    });
  };

  // handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState((prevState) => ({
  //     [name]: value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  // };

  handleInputChange = (e) => {
    const { name, value, type } = e.target;
    const newValue = type === 'file' ? e.target.files[0] : value;
    this.setState((prevState) => ({
      [name]: newValue,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleChange = (name, value) => {
    console.log(name, value);
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
}
  ViewLogo = () => {
    Swal.fire({
      title: 'Company Logo',
      html: `<img src='${this.state.company_logo_url}' style="max-width: 100%;" />`,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  };

  validateForm = () => {
    const errors = {};

    // if (!this.state.Corporate_identification_number) {
    //   errors.Corporate_identification_number = 'This is required';
    //   return errors;
    // }
    // if (!this.state.pan_number) {
    //   errors.pan_number = 'PAN Number is required';
    //   return errors;
    // }
    // if (!this.state.tan_number) {
    //   errors.tan_number = 'TAN Number is required';
    //   return errors;
    // }
    // if (!this.state.gstin_number) {
    //   errors.gstin_number = 'GSTIN Number is required';
    //   return errors;
    // }
    // if (!this.state.pf_number) {
    //   errors.pf_number = 'PF Number is required';
    //   return errors;
    // }
    // if (!this.state.establishment_under_pf) {
    //   errors.establishment_under_pf = 'This is required';
    //   return errors;
    // }
    if (this.state.establishment_under_pf==="1" && !this.state.pf_registration_number) {
      errors.pf_registration_number = 'This is required';
      return errors;
    }
    // if (!this.state.establishment_under_esic) {
    //   errors.establishment_under_esic = 'This is required';
    //   return errors;
    // }
    if (this.state.establishment_under_esic==="1" && !this.state.esic_registration_number) {
      errors.esic_registration_number = 'This is required';
      return errors;
    }
    // if (!this.state.establishment_under_pt) {
    //   errors.establishment_under_pt = 'This is required';
    //   return errors;
    // }
    if (this.state.establishment_under_pt==="1" && !this.state.pt_registration_number) {
      errors.pt_registration_number = 'This is required';
      return errors;
    }
    // if (!this.state.establishment_under_lwf) {
    //   errors.establishment_under_lwf = 'This is required';
    //   return errors;
    // }
    if (this.state.establishment_under_lwf==="1" && !this.state.lwf_registration_number) {
      errors.lwf_registration_number = 'This is required';
      return errors;
    }

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
    <div className="container mt-2">
    <form>
        <div className="row">
            {/* Corporate Identification Number  */}
            <div ref={this.Corporate_identification_number_ref} className="col-md-4 mb-3">
                <label htmlFor="Corporate_identification_number " className="form-label">Corporate Identification Number  
                    {/* <IsRequired /> */}
                    :</label>
                <input
                    type="text"
                    id="Corporate_identification_number "
                    name="Corporate_identification_number "
                    value={this.state.Corporate_identification_number }
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.Corporate_identification_number  ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.Corporate_identification_number  && <div className="invalid-feedback">{errors.Corporate_identification_number }</div>}
            </div>
            {/* PAN (Permanent Account Number)  */}
            <div ref={this.pan_number_ref} className="col-md-4 mb-3">
                <label htmlFor="pan_number" className="form-label">PAN (Permanent Account Number) 
                    {/* <IsRequired />  */}
                    :</label>
                <input
                    type="text"
                    id="pan_number"
                    name="pan_number"
                    value={this.state.pan_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.pan_number ? 'is-invalid' : ''}`}
                    placeholder="Enter PAN"
                />
                {errors.pan_number && <div className="invalid-feedback">{errors.pan_number}</div>}
            </div>
            {/* TAN (Tax Deduction and Collection)  */}
            <div ref={this.tan_number_ref} className="col-md-4 mb-3">
                <label htmlFor="tan_number" className="form-label">TAN (Tax Deduction and Collection) 
                    {/* <IsRequired />  */}
                    :</label>
                <input
                    type="text"
                    id="tan_number"
                    name="tan_number"
                    value={this.state.tan_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.tan_number ? 'is-invalid' : ''}`}
                    placeholder="Enter TAN"
                />
                {errors.tan_number && <div className="invalid-feedback">{errors.tan_number}</div>}
            </div>
            {/* GSTIN (Goods and Services Tax)  */}
            <div ref={this.gstin_number_ref} className="col-md-4 mb-3">
                <label htmlFor="gstin_number" className="form-label">GSTIN (Goods and Services Tax) 
                    {/* <IsRequired />  */}
                    :</label>
                <input
                    type="text"
                    id="gstin_number"
                    name="gstin_number"
                    value={this.state.gstin_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.gstin_number ? 'is-invalid' : ''}`}
                    placeholder="Enter GSTIN Number"
                />
                {errors.gstin_number && <div className="invalid-feedback">{errors.gstin_number}</div>}
            </div>
            {/* PF Registration Number  */}
            {/* <div ref={this.pf_number_ref} className="col-md-4 mb-3">
                <label htmlFor="pf_number" className="form-label">PF Registration Number 
                    <IsRequired /> 
                    :</label>
                <input
                    type="text"
                    id="pf_number"
                    name="pf_number"
                    value={this.state.pf_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.pf_number ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.pf_number && <div className="invalid-feedback">{errors.pf_number}</div>}
            </div> */}
             {/* Is the establishment covered under PF Act? */}
            <div ref={this.establishment_under_pf_ref} className="col-md-4">
                <label className="form-label">Is the establishment covered under PF Act?</label><br/>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_pf_yes"
                        name="establishment_under_pf"
                        value="1"
                        checked={this.state.establishment_under_pf === "1"}
                        onChange={() => this.handleChange("establishment_under_pf","1") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_pf_yes"
                        className="form-check-label"
                    >
                        Yes
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_pf_no"
                        name="establishment_under_pf"
                        value="0"
                        checked={this.state.establishment_under_pf === "0"}
                        onChange={() => this.handleChange("establishment_under_pf","0") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_pf_no"
                        className="form-check-label"
                    >
                        No
                    </label>
                </div>
                {errors.establishment_under_pf && <div className="invalid-feedback">{errors.establishment_under_pf}</div>}
            </div>
            {/* What is the PF Registration Number?  */}
            <div ref={this.pf_registration_number_ref} className="col-md-4 mb-3">
                <label htmlFor="pf_registration_number" className="form-label">What is the PF Registration Number? 
                    {this.state.establishment_under_pf === "1" && <IsRequired />} 
                    :</label>
                <input
                    type="text"
                    id="pf_registration_number"
                    name="pf_registration_number"
                    value={this.state.pf_registration_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.pf_registration_number ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.pf_registration_number && <div className="invalid-feedback">{errors.pf_registration_number}</div>}
            </div>
            {/* Is the establishment covered under ESIC Act? */}
            <div ref={this.establishment_under_esic_ref} className="col-md-4">
                <label className="form-label">Is the establishment covered under ESIC Act?</label><br/>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_esic_yes"
                        name="establishment_under_esic"
                        value="1"
                        checked={this.state.establishment_under_esic === "1"}
                        onChange={() => this.handleChange("establishment_under_esic","1") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_esic_yes"
                        className="form-check-label"
                    >
                        Yes
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_esic_no"
                        name="establishment_under_esic"
                        value="0"
                        checked={this.state.establishment_under_esic === "0"}
                        onChange={() => this.handleChange("establishment_under_esic","0") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_esic_no"
                        className="form-check-label"
                    >
                        No
                    </label>
                </div>
                {errors.establishment_under_esic && <div className="invalid-feedback">{errors.establishment_under_esic}</div>}
            </div>
            {/* What is the ESIC Registration Number? */}
            <div ref={this.esic_registration_number_ref} className="col-md-4 mb-3">
                <label htmlFor="esic_registration_number" className="form-label">What is the ESIC Registration Number? 
                    {this.state.establishment_under_esic === "1" && <IsRequired /> }
                    :</label>
                <input
                    type="text"
                    id="esic_registration_number"
                    name="esic_registration_number"
                    value={this.state.esic_registration_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.esic_registration_number ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.esic_registration_number && <div className="invalid-feedback">{errors.esic_registration_number}</div>}
            </div>
            {/* Is the establishment covered under PT Act? */}
            <div ref={this.establishment_under_pt_ref} className="col-md-4">
                <label className="form-label">Is the establishment covered under PT Act?</label><br/>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_pt_yes"
                        name="establishment_under_pt"
                        value="1"
                        checked={this.state.establishment_under_pt === "1"}
                        onChange={() => this.handleChange("establishment_under_pt","1") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_pt_yes"
                        className="form-check-label"
                    >
                        Yes
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_pt_no"
                        name="establishment_under_pt"
                        value="0"
                        checked={this.state.establishment_under_pt === "0"}
                        onChange={() => this.handleChange("establishment_under_pt","0") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_pt_no"
                        className="form-check-label"
                    >
                        No
                    </label>
                </div>
                {errors.establishment_under_pt && <div className="invalid-feedback">{errors.establishment_under_pt}</div>}
            </div>
            {/* What is the PT Registration Number? */}
            <div ref={this.pt_registration_number_ref} className="col-md-4 mb-3">
                <label htmlFor="pt_registration_number" className="form-label">What is the PT Registration Number? 
                    {this.state.establishment_under_pt === "1" && <IsRequired /> }
                    :</label>
                <input
                    type="text"
                    id="pt_registration_number"
                    name="pt_registration_number"
                    value={this.state.pt_registration_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.pt_registration_number ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.pt_registration_number && <div className="invalid-feedback">{errors.pt_registration_number}</div>}
            </div>
            {/* Is the establishment covered under LWF Act? */}
            <div ref={this.establishment_under_lwf_ref} className="col-md-4">
                <label className="form-label">Is the establishment covered under LWF Act?</label><br/>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_lwf_yes"
                        name="establishment_under_lwf"
                        value="1"
                        checked={this.state.establishment_under_lwf === "1"}
                        onChange={() => this.handleChange("establishment_under_lwf","1") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_lwf_yes"
                        className="form-check-label"
                    >
                        Yes
                    </label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        type="radio"
                        id="establishment_under_lwf_no"
                        name="establishment_under_lwf"
                        value="0"
                        checked={this.state.establishment_under_lwf === "0"}
                        onChange={() => this.handleChange("establishment_under_lwf","0") }
                        className="form-check-input"
                    />
                    <label
                        htmlFor="establishment_under_lwf_no"
                        className="form-check-label"
                    >
                        No
                    </label>
                </div>
                {errors.establishment_under_lwf && <div className="invalid-feedback">{errors.establishment_under_lwf}</div>}
            </div>
            {/* What is the LWF Registration Number? */}
            <div ref={this.lwf_registration_number_ref} className="col-md-4 mb-3">
                <label htmlFor="lwf_registration_number" className="form-label">What is the LWF Registration Number? 
                    {this.state.establishment_under_lwf === "1" && <IsRequired /> }
                    :</label>
                <input
                    type="text"
                    id="lwf_registration_number"
                    name="lwf_registration_number"
                    value={this.state.lwf_registration_number}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.lwf_registration_number ? 'is-invalid' : ''}`}
                    placeholder="Enter Number"
                />
                {errors.lwf_registration_number && <div className="invalid-feedback">{errors.lwf_registration_number}</div>}
            </div>
        </div>
    </form>
    <div className="d-flex justify-content-end gap-2">
        <SubmitButton onClick={(e)=>{ 
        if(!this.state.postLoading){
            this.setState({postLoading:true},
            ()=> this.handleSubmit(e))
            }  
        }}
        disabled={true}
        loading={this.state.postLoading}
        buttonName={this.state.company_id? 'Update':'Save'} icon={this.state.company_id? 'ri-edit-box-line' : 'ri-save-line'}
        type={this.state.company_id? 'secondary' : 'primary'} iconSide='left' 
        />
    </div>
    </div>
    );
  }
}

export default withRouter(CompanyStatutory);
